/*====================================
    商品加工 Factory
	
	加工價格與成本對應表有四層架構：
	總商品Map: <key, value> is <商品分類, 該分類加工Map>
	分類Map: <key, value> is <加工名稱, 該加工Map>
	加工Map: <key, value> is <城盛編號/或是DEFAULT, 價格成本Map>
	價格成本Map: <key, value> is <price/cost, 價格資訊>
	價格資訊: 
		priceRule: 計算方式，參考 PROCESS_PRICE_RULE
		countUnit: 以多少為一組。ex: 500張1000元countUnit就是500
		printingUnit: 印製單位（盒、張等等），存紀錄用
		countUnitPrice: 一組多少錢。ex: 500張1000元countUnitPrice就是1000
		basicPrice: 基本價，計算出來的價格若比基本價低就會以基本價為主
		platemakingPrice: 版費不是獨立計價，而是跟著某些加工走的。ex: 名片的燙金燙銀
		twoSideMultiple: 雙面價格倍率，通常不寫是1倍跟單面一樣
		modulesPrice: 模數對應的價格，內容為 Map<模數, 價格> 取小值, ex: {1: 0, 3: 200, 5: 500}, 4模為200元
		countPrice: 數量對應的價格，內容為 Map<數量, 價格> 取大值, ex: {100: 300, 500: 1300, 1000: 2500}, 800為2500元

	價格計算method更改時要記得同步更改後端

    Author : Gray
    建立時間 : 2017 / 06 / 15
    最後更新時間 : 2018 / 12 / 14
====================================*/

window.InifECShared.factory("ProcessPriceService", ['$q', 'ProductUtil', 'ProductService', function($q, ProductUtil, ProductService) {

	var factory = this;

	var PdtSpecProps = ProductUtil.PdtSpecProps; // 商品規格所有欄位

	var PROCESS_PRICE_RULE = {
		DEFAULT: 0, // 預設計算法：max(單價 * 數量 ／ 單量, 基本價)
	};
	
	var DEFALUT_KEY = 'DEFAULT';
	var PLATEMAKING_NAME = "開新版";

	var allPdtProcessPriceCostMap = {};
 
	// --------------------------------
	// [private] 取得規格的價格
	// --------------------------------
	var getProcessPrice = function(priceObj, orderSpec) {

		var result = {
			price: 0,
			platemakingPrice: 0,
		};

		var count = orderSpec.count;
		var specProps = orderSpec.specProps;

		if(!specProps) {
			return result;
		}

		var modulus = specProps[PdtSpecProps.Modulus] ? specProps[PdtSpecProps.Modulus] : 1;
		var isTwoSide = specProps[PdtSpecProps.IsTwoSide] ? specProps[PdtSpecProps.IsTwoSide] : false;
		var countUnit = priceObj.countUnit;
		var modulesPriceMap = priceObj.modulesPriceMap ? priceObj.modulesPriceMap : {};
		var modulesPrice;

		for(var i = modulus; i > 0; i--) {
			if(modulesPriceMap[i]) {
				modulesPrice = modulesPriceMap[i];
				break;
			}
		}

		if(!modulesPrice) {
			return result;
		}

		var _countUnitPrice = modulesPrice.countUnitPrice;
		var _basicPrice = modulesPrice.basicPrice;
		var _platemakingPrice = modulesPrice.platemakingPrice;

		switch(priceObj.priceRule) {
			case PROCESS_PRICE_RULE.DEFAULT:
				var quotient = Math.ceil(count / countUnit);

				if(isTwoSide) {
					_countUnitPrice = modulesPrice.countUnitPriceW;
					_platemakingPrice = modulesPrice.platemakingPriceW;
					_basicPrice = modulesPrice.basicPriceW;
				}

				result.price = quotient * _countUnitPrice;
				result.platemakingPrice = _platemakingPrice;

				if(result.price < _basicPrice) {
					result.price = _basicPrice;
				}

				break;
		}

		// 四捨五入
		result.price = Math.round(result.price);
		result.platemakingPrice = Math.round(result.platemakingPrice);

		return result;
	}

	// --------------------------------
	// [private] 取得某個規格的價格與成本
	// --------------------------------
	var getProcessPriceCost = function(productid, orderSpec, pdtProcessPriceCostMap, processKey) {

		var result = {
			price: 0,
			cost: 0,
			platemakingPrice: 0, // 版費另外記
			platemakingCost: 0, // 版費另外記
		}

		var processPriceCostMap = pdtProcessPriceCostMap[processKey];

		if(!processPriceCostMap) {
			return result;
		}

		var specProcess = processPriceCostMap[productid];

		if(!specProcess) {
			specProcess = processPriceCostMap['DEFAULT'];
		}

		if(!specProcess) {
			return result;
		}

		var processPrice = getProcessPrice(specProcess.price, orderSpec);
		var processCost = getProcessPrice(specProcess.cost, orderSpec);

		result.price = processPrice.price;
		result.cost = processCost.price;
		result.platemakingPrice = processPrice.platemakingPrice;
		result.platemakingCost = processCost.platemakingPrice;

		return result;
	}

    // --------------------------------
    // 取得商品加工總價
    // --------------------------------
    var getProductProcessPriceCost = function(product, orderSpec) {

    	var result = {
    		totalPrice: 0,
    		processPriceCost: {},
    	};

    	if(!product || !orderSpec) {
    		return result;
    	}

    	var processList = orderSpec.process;

    	if(!processList || processList.length == 0) {
    		return result;
    	};

    	var classProcessMap = allPdtProcessPriceCostMap[product.pdtClass];

    	if(!classProcessMap || !classProcessMap.pdtProcessPriceCostMap) {
    		return result;
    	}

    	var pdtProcessPriceCostMap = classProcessMap.pdtProcessPriceCostMap;

    	var _process,
    		_processKey,
    		_processPriceCost;

    	for(var i = 0; i < processList.length; i++) {
    		_process = processList[i];

    		if(!_process) {
    			continue;
    		}

    		_processKey = _process.key;

    		// 版費是依造其他加工所產生的，因此遇到版費跳過
    		if(_processKey == PLATEMAKING_NAME) {
    			continue;
    		}

    		_processPriceCost = getProcessPriceCost(product.productid, orderSpec, pdtProcessPriceCostMap, _processKey);

    		result.totalPrice += _processPriceCost.price;

    		// 結果有版費的話要將費用加入版費加工裡
    		if(_processPriceCost.platemakingPrice > 0 || _processPriceCost.platemakingCost > 0) {

    			if(!result.processPriceCost[PLATEMAKING_NAME]) {
    				result.processPriceCost[PLATEMAKING_NAME] = {
    					price: 0,
    					cost: 0,
    				}
    			}

    			result.processPriceCost[PLATEMAKING_NAME].price += _processPriceCost.platemakingPrice;
    			result.processPriceCost[PLATEMAKING_NAME].cost += _processPriceCost.platemakingCost;

    			result.totalPrice += _processPriceCost.platemakingPrice;
    		}

    		// 記錄該加工的費用成本
    		result.processPriceCost[_processKey] = {
    			price: _processPriceCost.price,
    			cost: _processPriceCost.cost,
    		};
    	}

    	return result;
    }

    // --------------------------------
	// 檢查是否已讀取資料了
	// --------------------------------
	var getIsLoaded = function() {

		return factory.isLoaded;
	}

    // --------------------------------
    // 載入資料
    // --------------------------------
    var loadInfo = function() {

    	var defer = $q.defer();

    	if(factory.isLoaded) {
    		defer.resolve(true);
    	} else {
    		return createBackEndObj(defer);
    	}

    	return defer.promise;
    }

    /**
     *
     * [DIFFERENT] 前後台審稿手機版行為不一樣的function 
     * 
     */

	// --------------------------------
	// [private] 用後端給的加工計價表
	// --------------------------------
	var createBackEndObj = function(defer) {

        ProductService.getProductClassListLite().then(function(result) {
            if(result && result.allPdtProcessPriceCostMap) {
            	allPdtProcessPriceCostMap = result.allPdtProcessPriceCostMap;
            	factory.isLoaded = true;
            }
            defer.resolve(true);
        }, function(error) {
        	defer.resolve(true);
        });

        return defer.promise;
	}

    // --------------------------------
    // [private] 初始化
    // --------------------------------
    var init = function() {

    	loadInfo();
    }

    //==========================
    //  Members
    //==========================
    factory.isLoaded = false;
    factory.PROCESS_PRICE_RULE = PROCESS_PRICE_RULE;
    factory.DEFALUT_KEY = DEFALUT_KEY;
    factory.PLATEMAKING_NAME = PLATEMAKING_NAME;

    //==========================
    //  Methods
    //==========================
    // 檢查是否已讀取資料了
    factory.getIsLoaded = getIsLoaded;
    // 取得商品加工總價
    factory.getProductProcessPriceCost = getProductProcessPriceCost;
    // 載入資料
    factory.loadInfo = loadInfo;

    //==========================
    //  Init
    //==========================
    init();

    return factory;
}]);
